import { dashboardReducer } from '@portal/app/store/dashboard/reducer';
import { multiViewReducer } from '@portal/app/store/multi-view/reducer';

export const reducers = {
  dashboard: dashboardReducer,
  multiView: multiViewReducer
};
